export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["FAILED_CONNECTION"] = "failed_connection";
    ErrorCode["BAD_REQUEST"] = "bad_request";
    ErrorCode["INVALID_SESSION"] = "invalid_session";
    ErrorCode["SESSION_EXPIRED"] = "session_expired";
    ErrorCode["INSUFFICIENT_PERMISSIONS"] = "insufficient_permissions";
    ErrorCode["NOT_FOUND"] = "not_found";
    ErrorCode["SERVER_ERROR"] = "server_error";
    ErrorCode["AUTHENTICATION_FAILED"] = "authentication_failed";
    ErrorCode["ENCODING_ERROR"] = "encoding_error";
    ErrorCode["VALIDATION_ERROR"] = "validation_error";
    ErrorCode["CONFLICT"] = "conflict";
    ErrorCode["NOT_SUPPORTED"] = "not_supported";
    ErrorCode["NOT_ALLOWED"] = "not_allowed";
    ErrorCode["FEATURE_UNAVAILABLE"] = "feature_unavailable";
    ErrorCode["COMPANY_SUSPENDED"] = "company_suspended";
    ErrorCode["TERMS_NOT_ACCEPTED"] = "terms_not_accepted";
    ErrorCode["OUTDATED_CLIENT"] = "outdated_client";
    ErrorCode["RATE_LIMIT_EXCEEDED"] = "rate_limit_exceeded";
    ErrorCode["WEAK_PASSWORD"] = "weak_password";
    ErrorCode["USAGE_LIMIT_EXCEEDED"] = "usage_limit_exceeded";
    ErrorCode["NO_AI_ASSISTANT_LICENSE"] = "no_ai_assistant_license";
})(ErrorCode || (ErrorCode = {}));
export class Err extends Error {
    constructor(code, message, opts = {}) {
        super(message || (opts.error && opts.error.message) || "");
        this.code = code;
        this.report = opts.report || false;
        this.display = opts.display || false;
        this.originalError = opts.error;
    }
    toString() {
        return `${this.code}: ${this.message}`;
    }
}
export function isAbortError(e) {
    return !!e && e.name === "AbortError";
}
//# sourceMappingURL=error.js.map